import { adminAccessFeature } from "@/features/admin-access";
import { approvalsFeature } from "@/features/approvals";
import { editorFeature } from "@/features/editor";
import { manualFeature } from "@/features/manual";
import { searchFeature } from "@/features/search";
import type { FeatureModule } from "@/types/feature";

/**
 * The feature registry. Adding a feature = build its folder, export a
 * FeatureModule, and add it to this array. The router and sidebar are derived
 * from this list, so nothing else in the shell needs editing.
 */
export const FEATURES: readonly FeatureModule[] = [
  manualFeature,
  editorFeature,
  approvalsFeature,
  adminAccessFeature,
  searchFeature,
];
